import styled from "styled-components";
import { size } from "styled-theme";
import { mobileBreakPoint } from "./constants";
import LogoImageRentBond from "@theme/assets/rent_bond-logo.svg";
import React from "react";

const RentBondLogoWrapper = styled.div`
  padding-top: 5px;
  width: 120px;
  
  img {
    width: auto;
    max-height: 25px;
  }
  
  @media only screen and (max-width: ${size(mobileBreakPoint)}) {
    width: 72px;
  }
`;

export const RentBondLogo = () => (
  <RentBondLogoWrapper>
    <img src={LogoImageRentBond} alt="logo" />
  </RentBondLogoWrapper>
);